import React, { useEffect, useState } from "react";

export const DURATION_UNITS = { minutes: 60, hours: 3600, days: 86400 };

export function secondsToDuration(seconds) {
  const total = Math.max(0, Number(seconds) || 0);
  const unit = total > 0 && total % DURATION_UNITS.days === 0
    ? "days"
    : total > 0 && total % DURATION_UNITS.hours === 0 ? "hours" : "minutes";
  return { value: Number((total / DURATION_UNITS[unit]).toFixed(12)), unit };
}

export function durationToSeconds(value, unit) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric < 0 || !DURATION_UNITS[unit]) return 0;
  return Math.round(numeric * DURATION_UNITS[unit]);
}

export function formatDuration(seconds) {
  let remaining = Math.max(0, Math.round(Number(seconds) || 0));
  if (!remaining) return "0 minutes";
  const parts = [];
  for (const [unit, size] of [["day", 86400], ["hour", 3600]]) {
    const amount = Math.floor(remaining / size);
    if (amount) {
      parts.push(`${amount} ${unit}${amount === 1 ? "" : "s"}`);
      remaining %= size;
    }
  }
  if (remaining) {
    const minutes = Number((remaining / 60).toFixed(2));
    parts.push(`${minutes} minute${minutes === 1 ? "" : "s"}`);
  }
  return parts.join(" ");
}

export default function DurationInput({ seconds, onChange, ariaLabel = "Duration", disabled = false }) {
  const converted = secondsToDuration(seconds);
  const [unit, setUnit] = useState(converted.unit);

  useEffect(() => {
    setUnit(current => Number.isInteger(Number(seconds) / DURATION_UNITS[current])
      ? current
      : secondsToDuration(seconds).unit);
  }, [seconds]);

  const value = Number((Math.max(0, Number(seconds) || 0) / DURATION_UNITS[unit]).toFixed(12));
  return (
    <div className="mt-1 flex gap-2">
      <input aria-label={`${ariaLabel} value`} type="number" min="0" step="any" value={value}
        disabled={disabled} onChange={event => onChange(durationToSeconds(event.target.value, unit))}
        className="block min-w-0 flex-1 rounded-md border border-slate-300 px-3 py-2 text-sm" />
      <select aria-label={`${ariaLabel} unit`} value={unit} disabled={disabled}
        onChange={event => {
          setUnit(event.target.value);
          onChange(durationToSeconds(value, event.target.value));
        }} className="rounded-md border border-slate-300 px-3 py-2 text-sm">
        {Object.keys(DURATION_UNITS).map(option => (
          <option key={option} value={option}>{value === 1 ? option.slice(0, -1) : option}</option>
        ))}
      </select>
    </div>
  );
}
